import React, { useEffect, useRef } from "react";
import { loadGoogle, COUNTRIES } from "../lib/googleMaps";

// Google Places Autocomplete input. Calls onSelect({label, lat, lng}) on choose.
const AddressAutocomplete = ({ value, onChange, onSelect, placeholder, className, icon: Icon, preserveText = false }) => {
  const inputRef = useRef(null);
  const acRef = useRef(null);

  useEffect(() => {
    let active = true;
    loadGoogle()
      .then((g) => {
        if (!active || !inputRef.current || acRef.current) return;
        acRef.current = new g.maps.places.Autocomplete(inputRef.current, {
          fields: ["geometry", "formatted_address", "name", "types"],
          componentRestrictions: { country: COUNTRIES },
        });
        const ACCEPT = ["establishment", "point_of_interest", "airport", "premise", "subpremise", "street_address", "route", "intersection", "locality", "sublocality", "postal_code", "transit_station", "train_station", "bus_station", "neighborhood", "plus_code"];
        const COUNTRY_ONLY = /^(schweiz|switzerland|suisse|svizzera|liechtenstein|österreich|austria|deutschland|germany|france|frankreich|italia|italien|italy)$/i;
        acRef.current.addListener("place_changed", () => {
          const place = acRef.current.getPlace();
          if (!place || !place.geometry || !place.geometry.location) return;
          const types = place.types || [];
          const label = (place.formatted_address || place.name || "").trim();
          // Only accept specific places; reject vague country/region matches (e.g. "Schweiz").
          if (label.length < 4 || COUNTRY_ONLY.test(label)) return;
          if (!types.some((t) => ACCEPT.includes(t))) return;
          onSelect({
            label,
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          });
          if (onChange && !preserveText) onChange(label);
        });
      })
      .catch(() => {});
    return () => { active = false; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="relative">
      {Icon && <Icon size={17} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#9CA0B0] pointer-events-none z-10" />}
      <input
        ref={inputRef}
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        placeholder={placeholder}
        className={className}
      />
    </div>
  );
};

export default AddressAutocomplete;
